import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const accountingDayRoutingSerializeMap: SerializeMap<AccountingDayRoutingSuggestion> =
  {
    id: "id",
    suggestCashAccount: "suggest_cash_account",
    alreadyRoutedToCash: "already_routed_to_cash",
  };

export const deserializeAccountingDayRouting = buildDeserializer(
  accountingDayRoutingSerializeMap,
  "accounting day routing suggestion",
);

export const serializeAccountingDayRouting = buildSerializer(
  accountingDayRoutingSerializeMap,
  "accounting day routing suggestion",
);
